module.exports = __webpack_public_path__ + "img/office.a81d5ef9.webp";